module.exports = __webpack_public_path__ + "static/img/dryer--small.edb61ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bathroom/dryer--small.svg
// module id = 145
// module chunks = 2